module.exports = __webpack_public_path__ + "static/media/pointsBlack.25bd0128.svg";